'use client'
import type { ReactNode, ButtonHTMLAttributes, InputHTMLAttributes,
  SelectHTMLAttributes, TextareaHTMLAttributes } from 'react'
import { createContext, useContext, useEffect, useId, useRef, useState } from 'react'
import { cx } from '../utils'

// ── Button ──

type ButtonVariant = 'primary' | 'default' | 'ghost' | 'danger'
type ButtonSize = 'sm' | 'md'

const BUTTON_VARIANTS: Record<ButtonVariant, string> = {
  primary:
    'bg-accent-fill text-white border-accent hover:bg-accent-hover shadow-[0_1px_2px_rgba(194,101,42,0.2)] disabled:bg-accent-soft disabled:border-line-strong disabled:shadow-none',
  default:
    'bg-surface text-ink border-line-strong shadow-[var(--shadow-xs)] hover:bg-sunken hover:border-accent disabled:text-ink-3 disabled:shadow-none',
  ghost:
    'bg-transparent text-ink-2 border-transparent hover:bg-accent-soft hover:text-ink disabled:text-ink-3',
  danger:
    'bg-surface text-danger border-line-strong shadow-[var(--shadow-xs)] hover:bg-[#fbf1f0] hover:border-danger/40',
}

export function Button({
  variant = 'default',
  size = 'md',
  className,
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant
  size?: ButtonSize
}) {
  return (
    <button
      {...rest}
      type={rest.type || 'button'}
      className={cx(
        'pxs-focus inline-flex items-center justify-center gap-1.5 rounded-xs border font-medium whitespace-nowrap transition-all duration-100 select-none disabled:cursor-not-allowed disabled:opacity-70',
        size === 'sm' ? 'h-8 px-3 text-[14px]' : 'h-9 px-3.5 text-[15px]',
        BUTTON_VARIANTS[variant],
        className,
      )}
    />
  )
}
